"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TelemetryEnums_1 = require("@CommonFrontend/Telemetry/TelemetryEnums");
var TelemetryEventName_1 = require("@CommonFrontendBackend/Telemetry/TelemetryEventName");
var snakeCase_1 = __importDefault(require("lodash/snakeCase"));
var ProjectCreatedEvent_1 = require("@CommonFrontendBackend/Telemetry/ProjectCreatedEvent");
var CreatePageTelemetry = (function () {
    function CreatePageTelemetry(telemetry, serverTelemetry) {
        var _this = this;
        this.telemetry = telemetry;
        this.serverTelemetry = serverTelemetry;
        this.createPageInitiatedFromQwilr = function (templateId) {
            _this.telemetry.track("Create Page Initiated", {
                source: getCPASource(),
                template_id: templateId,
            }, {
                blockIdentify: true,
            });
        };
        this.createPageInitiatedFromCrm = function (integration, objectType, objectId) {
            _this.telemetry.track("Create Page Initiated", {
                source: "crm",
                integration: integration,
                object_type: objectType,
                object_id: objectId,
            }, {
                blockIdentify: true,
            });
        };
        this.preConditionClicked = function (preconditionText) {
            _this.telemetry.track("".concat(preconditionText, " clicked"), {}, { blockIdentify: true });
        };
        this.movedStep = function (stepName, direction, templateId, integrationName, errorMessage) {
            var eventName = direction ? "CPA - Next Step" : "CPA - Previous Step";
            var properties = {
                moving_to: stepName,
            };
            if (integrationName)
                properties.integration_name = integrationName;
            if (templateId)
                properties.template_id = templateId;
            if (errorMessage)
                properties.error_message = errorMessage;
            _this.telemetry.track(eventName, properties, { blockIdentify: true });
        };
        this.pageTitleEdited = function (pageTitle) {
            _this.telemetry.track("Page Title Edited", { new_title: pageTitle }, { blockIdentify: true });
        };
        this.outputFolderChanged = function (folderName) {
            _this.telemetry.track("Output Folder Changed", { folder_name: folderName }, { blockIdentify: true });
        };
        this.newFolderCreated = function (folderName) {
            _this.telemetry.track("New Folder Created", { folder_name: folderName }, { blockIdentify: true });
        };
        this.tokenResolutionDataToggled = function (collapsed, unresolvedTokens) {
            _this.telemetry.track("Tokens Resolution Data ".concat(!collapsed ? "expanded" : "collapsed"), {
                unresolved_tokens: unresolvedTokens,
            }, {
                blockIdentify: true,
            });
        };
        this.tokensResolved = function (resolvedTokens, unresolvedTokens) {
            _this.telemetry.track("Tokens Resolved", {
                resolved_tokens: resolvedTokens,
                unresolved_tokens: unresolvedTokens,
            }, {
                blockIdentify: true,
            });
        };
        this.projectCreated = function (_a) {
            var _b = _a === void 0 ? {} : _a, integrationName = _b.integrationName, templateId = _b.templateId, source = _b.source;
            var eventProperties = {
                templateId: templateId,
                integrationName: integrationName,
                projectCreationSource: getCPASource(),
                projectSource: source,
                projectScreenUsed: false,
                projectCreationUiOrigin: ProjectCreatedEvent_1.ProjectCreationUiOrigin.TemplateGallery,
                projectCreationMethod: ProjectCreatedEvent_1.ProjectCreationMethod.FromTemplate,
                projectCreationRequiredForm: false,
                projectCreationContentOrigin: ProjectCreatedEvent_1.ProjectContentOrigin.UserTemplate,
            };
            _this.serverTelemetry.sendProjectCreatedTelemetry({
                eventProperties: eventProperties,
            });
        };
        this.collaboratorLinkCopied = function (integration) {
            var _a;
            _this.telemetry.track(TelemetryEventName_1.TelemetryEventName.CollaboratorLinkCopied, (_a = {},
                _a["".concat((0, snakeCase_1.default)(TelemetryEventName_1.TelemetryEventName.CollaboratorLinkCopied), "_source")] = TelemetryEnums_1.TelemetrySource.CreatePageApp,
                _a.integration = integration,
                _a), {
                blockIdentify: true,
            });
        };
        this.publicLinkCopied = function (integration) {
            var _a;
            _this.telemetry.track(TelemetryEventName_1.TelemetryEventName.PublicLinkCopied, (_a = {},
                _a["".concat((0, snakeCase_1.default)(TelemetryEventName_1.TelemetryEventName.PublicLinkCopied), "_source")] = TelemetryEnums_1.TelemetrySource.CreatePageApp,
                _a.integration = integration,
                _a), {
                blockIdentify: true,
            });
        };
        this.editPageClicked = function () {
            _this.telemetry.track("Edit Page Clicked", {}, { blockIdentify: true });
        };
        this.pageStatusChanged = function (status) {
            _this.telemetry.track("Page Status Changed", {
                source: TelemetryEnums_1.TelemetrySource.CreatePageApp,
                status: status.status == "" ? "draft" : status.status,
            }, {
                blockIdentify: true,
            });
        };
        this.telemetry = telemetry;
        this.serverTelemetry = serverTelemetry;
    }
    return CreatePageTelemetry;
}());
var getCPASource = function () {
    var href = document.location.href;
    var paramsString = href.split("/")[4];
    if (paramsString == "templates-gallery" || "templates")
        return "template-gallery";
    if (paramsString == "page") {
        var source = new URLSearchParams(href.split("?")[1]).get("source");
        return source ? source : "template-editor";
    }
    return "not found";
};
exports.default = CreatePageTelemetry;
